import { render, staticRenderFns } from "./References.vue?vue&type=template&id=44b1bec6&scoped=true&"
import script from "./References.vue?vue&type=script&lang=js&"
export * from "./References.vue?vue&type=script&lang=js&"
import style0 from "./References.vue?vue&type=style&index=0&id=44b1bec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b1bec6",
  null
  
)

/* custom blocks */
import block0 from "./References.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports